export default __webpack_public_path__ + "static/open-graph-image-b9f0ae7c2781e69e8370a22dece74fae.png";